export const sectionLabels = {
  works: 'Work',
  performances: 'Performance',
  bio: 'Bio',
  home: 'Home',
};

let pagefind = null;

export function sectionLabel(meta) {
  const key = meta?.section;
  if (!key) return '';
  return sectionLabels[key] || key.charAt(0).toUpperCase() + key.slice(1);
}

/** @param {(message: string) => void} [onError] */
export async function getPagefind(onError) {
  if (pagefind) return pagefind;
  try {
    const pf = await import('/pagefind/pagefind.js');
    await pf.options({ baseUrl: '/' });
    await pf.init();
    pagefind = pf;
    return pf;
  } catch (err) {
    console.error('Pagefind failed to load:', err);
    onError?.(
      'Search index is not available. Run a full build (npm run build) to generate it.'
    );
    return null;
  }
}

/**
 * @param {object} item
 * @param {{ compact?: boolean }} [options]
 */
export function buildResultItem(item, { compact = false } = {}) {
  const li = document.createElement('li');
  li.className = compact ? 'search-result search-result--compact' : 'search-result';
  const title = item.meta?.title || item.url;
  const section = sectionLabel(item.meta);
  const link = document.createElement('a');
  link.className = 'search-result__link';
  link.href = item.url;
  const titleEl = document.createElement('span');
  titleEl.className = 'search-result__title';
  titleEl.textContent = title;
  link.append(titleEl);
  if (section) {
    const badge = document.createElement('span');
    badge.className = 'search-result__section';
    badge.textContent = section;
    link.append(badge);
  }
  li.append(link);
  if (!compact && item.excerpt) {
    const excerpt = document.createElement('p');
    excerpt.className = 'search-result__excerpt';
    excerpt.innerHTML = item.excerpt;
    li.append(excerpt);
  }
  return li;
}

/**
 * @returns {Promise<{ data: object[], total: number } | null>}
 */
export async function fetchSearchResults(term, { limit = 25, onError } = {}) {
  const q = term.trim();
  if (!q) return { data: [], total: 0 };

  const pf = await getPagefind(onError);
  if (!pf) return { data: [], total: 0 };

  const search = await pf.debouncedSearch(q);
  if (search === null) return null;

  const data = await Promise.all(
    search.results.slice(0, limit).map((r) => r.data())
  );
  return { data, total: search.results.length };
}

export function preloadSearch(term) {
  pagefind?.preload?.(term);
}
